import React from 'react'
import classNames from 'classnames'
import HorizontalLineNew from 'root/src/client/web/base/HorizontalLineNew'

export default ({
	scrollPosition, isAutoScroll, setIsAutoScroll, classes,
}) => (
	<div className={classes.buttonsContainer}>
		<button
			type="button"
			onClick={() => scrollPosition(-1)}
			className={classNames(classes.navButton, classes.outherButton)}
		>
			<HorizontalLineNew
				className={classNames(classes.line, classes.innerLine)}
				dimmed
			/>
		</button>
		<button
			type="button"
			onClick={() => setIsAutoScroll(!isAutoScroll)}
			className={classNames(classes.navButton, classes.innerButton)}
		>
			<HorizontalLineNew
				className={classNames(classes.line, classes.innerLine)}
				dimmed={!isAutoScroll}
			/>
		</button>
		<button
			type="button"
			onClick={() => scrollPosition(1)}
			className={classNames(classes.navButton, classes.outherButton)}
		>
			<HorizontalLineNew
				className={classNames(classes.line, classes.innerLine)}
				dimmed
			/>
		</button>
	</div>
)
